import { component as defineComponent } from 'flightjs'; // eslint-disable-line no-restricted-imports

function UpdateText() {
    this.defaultAttrs({
        dataKey: null,
        eventName: null,
    });

    this.after('initialize', function() {
        this.on(document, this.attr.eventName, this.updateText);
    });

    this.updateText = function(e, data) {
        const self = this;
        if (data[this.attr.dataKey] != undefined) {
            if (this.attr.fade) {
                this.$node.fadeOut(200, () => {
                    self.$node.text(data[self.attr.dataKey]);
                    self.$node.fadeIn(200);
                });
            } else {
                this.$node.text(data[this.attr.dataKey]);
            }
        }
    };
}

export default defineComponent(UpdateText);



// WEBPACK FOOTER //
// ./src/js/component_ui/update-text.js